import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CPMMState } from '../../../../../../aumico-lib-users-fe/src/lib/enums/cpmm-state.enum';
import { OrganizationProvider } from '../../../../../../aumico-lib-users-fe/src/public-api';

@UntilDestroy()
@Component({
    selector: 'tasks-and-closing-advertising-page',
    templateUrl: './tasks-and-closing-advertising.page.html',
    styleUrls: ['./tasks-and-closing-advertising.page.scss'],
})
export class TasksAndClosingAdvertisingPage implements OnInit {
    showUpgradePopup: boolean = false;
    showWelcomePopup: boolean = false;
    isActivating: boolean = false;
    cpmmIsActive: boolean = false;
    organizationId: string;
    constructor(
        private organizationProvider: OrganizationProvider,
        private router: Router,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.organizationProvider.getCurrentOrganization$().subscribe((organization) => {
            this.organizationId = organization?.id;
            this.isActivating = false;
            if (!organization || !organization.cpmmActivationDetails) {
                this.showUpgradePopup = false;
                this.showWelcomePopup = false;
                this.cpmmIsActive = false;
                return;
            }
            if (organization && organization.cpmmActivationDetails.activationState === CPMMState.INACTIVE) {
                this.showUpgradePopup = false;
                this.showWelcomePopup = false;
                this.cpmmIsActive = false;
            } else if (organization && organization.cpmmActivationDetails.activationState === CPMMState.ACTIVE) {
                this.showUpgradePopup = false;
                this.showWelcomePopup = true;
                this.cpmmIsActive = true;
            }
        });
    }

    upgrade() {
        this.showUpgradePopup = true;
    }

    welcome() {
        this.showWelcomePopup = true;
    }

    cancelUpgradeRequest(): void {
        this.showUpgradePopup = false;
    }

    closeUpgradeRequest(): void {
        this.showUpgradePopup = false;

        this.organizationProvider.dispatchChangeCPMMState(this.organizationId, CPMMState.ACTIVE);

        this.isActivating = true;
        setTimeout(() => {
            this.isActivating = false;
            this.showWelcomePopup = true;
        }, 3000);
    }

    closeWelcome(): void {
        this.showWelcomePopup = false;
    }

    closeWelcomeAndStart(): void {
        this.showWelcomePopup = false;
        // open a link in a new tab
        window.open('https://meetings.hubspot.com/cbartosch/onboarding-mandats-und-aufgabenmanagement-abschlussprozess', '_blank');
        this.router.navigate(['../companies/overview'], { relativeTo: this.route });
    }
}
